import getMessage from 'src/background/utils/i18n.utils';
import { setInfoMessage } from '@popup/multichain/actions/message.actions';
import { SwapStatus } from '@steempro/steem-keychain-commons';
import moment from 'moment';
import { default as React, useState } from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import FormatUtils from 'src/utils/format.utils';
const TokenSwapsHistoryItem = ({ swap, setInfoMessage }) => {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const copyIdToCliplboard = (id) => {
        navigator.clipboard.writeText(id.toString());
        setInfoMessage('swap_copied_to_clipboard');
    };
    const getStatusMessage = (status, transferInitiated) => {
        switch (status) {
            case SwapStatus.PENDING:
                return transferInitiated
                    ? getMessage('swap_status_pending')
                    : getMessage('swap_transfer_not_sent');
            case SwapStatus.COMPLETED:
                return getMessage('swap_status_completed');
            case SwapStatus.CANCELED_DUE_TO_ERROR:
                return getMessage('swap_status_canceled_due_to_error');
            case SwapStatus.FUNDS_RETURNED:
                return getMessage('swap_status_returned');
            case SwapStatus.REFUNDED_SLIPPAGE:
                return getMessage('swap_status_refunded');
            case SwapStatus.STARTED:
                return getMessage('swap_status_started');
        }
    };
    const getStatusIcon = (status) => {
        switch (status) {
            case SwapStatus.PENDING:
            case SwapStatus.STARTED:
                return SVGIcons.SWAPS_STATUS_PROCESSING;
            case SwapStatus.COMPLETED:
                return SVGIcons.SWAPS_STATUS_FINISHED;
            case SwapStatus.CANCELED_DUE_TO_ERROR:
            case SwapStatus.FUNDS_RETURNED:
            case SwapStatus.REFUNDED_SLIPPAGE:
                return SVGIcons.SWAPS_STATUS_CANCELED;
        }
    };
    const getShortenedId = (id) => {
        return id.substring(0, 6) + '...' + id.slice(-6);
    };
    const getStepIcon = (status) => {
        switch (status) {
            case 'success':
                return SVGIcons.SWAPS_STATUS_FINISHED;
            case 'pending':
                return SVGIcons.SWAPS_STATUS_PROCESSING;
            case 'failed':
                return SVGIcons.SWAPS_STATUS_CANCELED;
            default:
                return SVGIcons.SWAPS_STATUS_PROCESSING;
        }
    };
    function getTooltipMessage(swap) {
        return `${getStatusMessage(swap.status, swap.transferInitiated)}
      <br/> ${[SwapStatus.PENDING, SwapStatus.STARTED].includes(swap.status)
            ? getMessage('swap_last_update', [
                moment(swap.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
            ])
            : moment(swap.updatedAt).format('YYYY-MM-DD HH:mm:ss')}`;
    }
    return (React.createElement("div", { className: `history-item` },
        React.createElement("div", { className: "history-item-information" },
            React.createElement("div", { className: "swap-details" },
                React.createElement("div", { className: "swap-item-icon-container" },
                    React.createElement(SVGIcon, { icon: SVGIcons.SWAPS_ITEM, className: "swap-item-icon" })),
                React.createElement("span", { className: "token token-from" },
                    swap.amount,
                    " ",
                    swap.startToken),
                ' ',
                React.createElement(SVGIcon, { icon: SVGIcons.SWAPS_BETWEEN, className: "swap-between" }),
                ' ',
                React.createElement("div", { className: "token token-to" },
                    swap.status === SwapStatus.COMPLETED ? ('') : (React.createElement("span", { className: "approximate" }, "~")),
                    ' ', (_a = swap.received) !== null && _a !== void 0 ? _a : FormatUtils.withCommas(Number(swap.expectedAmountAfterFee).toString(), 3, true),
                    ' ',
                    swap.endToken),
                React.createElement(SVGIcon, { icon: SVGIcons.SWAPS_EXPAND, className: `expand-panel ${isOpen ? 'opened' : 'closed'}`, onClick: () => setIsOpen(!isOpen) }),
                React.createElement(CustomTooltip, { position: "left", skipTranslation: true, message: getTooltipMessage(swap) },
                    React.createElement(SVGIcon, { icon: getStatusIcon(swap.status), className: "status-icon" }))),
            isOpen && (React.createElement("div", { className: "swap-item-history" },
                swap.history
                    .sort((a, b) => a.stepNumber - b.stepNumber)
                    .map((step) => (React.createElement("div", { className: "step", key: swap.id + '' + step.stepNumber },
                    React.createElement("div", { className: "step-number" }, step.stepNumber),
                    React.createElement("div", { className: "details" },
                        React.createElement("div", { className: "description" },
                            FormatUtils.withCommas(step.amountStartToken + '', 3, true),
                            ' ',
                            step.startToken,
                            " ",
                            '=>',
                            ' ',
                            step.amountEndToken
                                ? FormatUtils.withCommas(step.amountEndToken + '', 3, true)
                                : '...',
                            ' ',
                            step.endToken)),
                    React.createElement(SVGIcon, { icon: getStepIcon(step.status), className: `step-status ${step.status}` })))),
                !!swap.fee && (React.createElement("div", { className: "step" },
                    React.createElement("div", { className: "step-number" }, getMessage('swap_fee')),
                    ' ',
                    React.createElement("div", { className: "details" },
                        React.createElement("div", { className: "description" },
                            swap.fee,
                            " ",
                            swap.endToken)))),
                React.createElement("div", { className: "step" },
                    React.createElement("div", { className: "step-number" }, "ID"),
                    React.createElement("div", { className: "id", onClick: () => copyIdToCliplboard(swap.id) }, getShortenedId(swap.id))))))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, { setInfoMessage });
export const TokenSwapsHistoryItemComponent = connector(TokenSwapsHistoryItem);
